import React from "react";
import cookie from "react-cookies";
import queryString from "query-string";
import { Helmet } from "react-helmet";

import { getLandingPage, getHomePage } from "../../model/common";

import { commonErr } from "../common/errors";
import { getHCMCityCoordinates, moment, stypes } from "../common/common";

import Header from "../components/header";
import Footer from "../components/footer";

import Cover from "./cover";
import Features from "./features";
import OurService from "./service";
import Tutorial from "./tutorial";
import Explorer from "./explorer";
import AboutUs from "./aboutus";
import AppAds from "./appads";
import AppInstall from "./appinstall";
import Blogs from "./blogs";
import Insurance from "./insurance";
import Destination from "./destination";
import AirportDelivery from "./airportdelivery";
import FeatureCars from "./featurecars";
import AdsPromos from "./adspromos";
import AboutCS from "../carsubscription/home/aboutcs";
import Advantage from "../carsubscription/home/advantage";
import Customer from "../carsubscription/home/customer";
import PartnerGarage from "../carsubscription/home/partnergarage";
import FeatureCarsCS from "../carsubscription/home/featurecarscs";

import { HiddenLink } from "../common/hiddenlink";

class LandingPage extends React.Component {
	constructor() {
		super();
		this.state = {
			sdTopDes: null,
			wdTopDes: null,
			sdAirDel: null,
			wdAirDel: null,
			adsPromos: [],
			stype: stypes.SD,
			isMCalendar: false,
			lat: getHCMCityCoordinates.lat,
			lng: getHCMCityCoordinates.lng,
			startDate: moment()
				.set({
					hour: 21,
					minute: 0,
					second: 0,
					milliseconds: 0,
				})
				.valueOf(),
			endDate: moment()
				.add(1, "days")
				.set({
					hour: 20,
					minute: 0,
					second: 0,
					milliseconds: 0,
				})
				.valueOf(),
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const { lat, lng, startDate, endDate } = this.state;

		getLandingPage().then((landingPageResp) => {
			if (landingPageResp.data.error === commonErr.SUCCESS) {
				this.setState({
					sdTopDes: landingPageResp.data.data.sdTopDes,
					wdTopDes: landingPageResp.data.data.wdTopDes,
					adsPromos: landingPageResp.data.data.adsPromos,
				});
			}
		});
		getHomePage(lat, lng, startDate, endDate).then((homePageResp) => {
			if (homePageResp.data.error === commonErr.SUCCESS) {
				this.setState({
					sdFeatureCars: homePageResp.data.data.sd.featureCars,
					sdAirDel: homePageResp.data.data.sd.deliveryLocations,
					wdFeatureCars: homePageResp.data.data.wd.featureCars,
					wdAirDel: homePageResp.data.data.wd.deliveryLocations,
				});
			}
		});

		//GA
		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);

			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_campaign) {
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/" });
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_ext) {
				cookie.save("_utm_ext", query.utm_ext, { path: "/" });
				cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
			} else {
				cookie.remove("_utm_ext", { path: "/" });
				cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
			}
		}

		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "VIEW_HOME", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		window.fbq("track", "VIEW_HOME");
		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow();
	}

	componentDidUpdate(prevProps, prevState) {
		const { lat, lng, startDate, endDate } = this.state;
		if (
			prevState.lat !== lat ||
			prevState.lng !== lng ||
			prevState.startDate !== startDate ||
			prevState.endDate !== endDate
		) {
			getHomePage(lat, lng, startDate, endDate).then((homePageResp) => {
				if (homePageResp.data.error === commonErr.SUCCESS) {
					this.setState({
						sdFeatureCars: homePageResp.data.data.sd.featureCars,
						sdAirDel: homePageResp.data.data.sd.deliveryLocations,
						wdFeatureCars: homePageResp.data.data.wd.featureCars,
						wdAirDel: homePageResp.data.data.wd.deliveryLocations,
					});
				}
			});
		}
	}

	checkWidthWindow = () => {
		if (window.innerWidth <= 991) {
			this.setState({
				isMCalendar: true,
			});
		} else {
			this.setState({
				isMCalendar: false,
			});
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow();
	};

	onSType = (stype) => {
		this.setState({
			stype,
		});
	};

	onSearchParams = (pLat, pLng, pSt, pEt) => {
		if (pLat !== undefined && pLng !== undefined) {
			this.setState({
				lat: pLat,
				lng: pLng,
			});
		}
		if (pSt !== undefined && pEt !== undefined) {
			this.setState({
				startDate: pSt,
				endDate: pEt,
			});
		}
	};

	render() {
		const { sdTopDes, wdTopDes, adsPromos, sdFeatureCars, wdFeatureCars, sdAirDel, wdAirDel, stype, isMCalendar } =
			this.state;

		return (
			<div className="mioto-layout">
				<HiddenLink />
				<Header notLineHeader={true} />
				<section className="body">
					{sdTopDes && (
						<Cover
							stype={stype}
							onSType={this.onSType}
							onSearchParams={this.onSearchParams}
							isMCalendar={isMCalendar}
							topDests={sdTopDes}
						/>
					)}

					{stype === stypes.CS && (
						<>
							<AboutCS />
							{/* <FeatureCarsCS /> */}
							<Advantage />
							<Customer />
							<PartnerGarage />
						</>
					)}

					{stype === stypes.SD && (
						<>
							{adsPromos && adsPromos.length ? <AdsPromos adsPromos={adsPromos} /> : null}
							{sdFeatureCars && <FeatureCars stype={stypes.SD} cars={sdFeatureCars} />}
							<div className="topdes-section space sec">
								{sdTopDes && <Destination stype={stypes.SD} topDests={sdTopDes} />}
								{sdAirDel && <AirportDelivery stype={stypes.SD} airDelivery={sdAirDel} />}
							</div>
						</>
					)}

					{stype === stypes.WD && (
						<>
							{adsPromos && adsPromos.length ? <AdsPromos adsPromos={adsPromos} /> : null}
							{wdFeatureCars && <FeatureCars stype={stypes.WD} cars={wdFeatureCars} />}
							<div className="topdes-section space sec">
								{stype === stypes.WD && wdTopDes && <Destination stype={stypes.WD} topDests={wdTopDes} />}
								{stype === stypes.WD && wdAirDel && <AirportDelivery stype={stypes.WD} airDelivery={wdAirDel} />}
							</div>
						</>
					)}

					{stype !== stypes.CS && (
						<>
							<Features />
							<Insurance />
							<OurService />
							<Tutorial />
							<AboutUs />
							<Explorer />
							<AppAds />
							<Blogs />
							<AppInstall />
						</>
					)}
				</section>
				<Footer />
			</div>
		);
	}
}
export default LandingPage;
